// eslint-disable-next-line import/prefer-default-export
export function formatNumber(number: number | string | null, length = 2): string {
  const value = Number(number);
  if (Number.isNaN(value)) {
    return String(number);
  }

  if (number === null) {
    return '-';
  }

  return value.toFixed(length);
}
